import { Controller } from "@hotwired/stimulus"

export async function copyText(text, { clipboard = globalThis.navigator?.clipboard, document = globalThis.document } = {}) {
  if (!text) return false

  try {
    if (clipboard?.writeText) {
      await clipboard.writeText(text)
      return true
    }
  } catch (_error) {
    // Continue with the legacy copy path when browser permission is denied.
  }

  const input = document?.createElement?.("textarea")
  if (!input || !document.body) return false

  input.value = text
  input.readOnly = true
  document.body.append(input)
  input.select()
  const copied = document.execCommand?.("copy") === true
  input.remove()
  return copied
}

export default class extends Controller {
  static targets = ["status"]
  static values = { copied: String, failed: String, text: String }

  async copy() {
    const copied = await copyText(this.hasTextValue ? this.textValue : window.location.href)
    this.statusTarget.textContent = copied ? this.copiedValue : this.failedValue
  }
}
